// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as React from "react";
import { getEnv } from "../../utils/env";
import { ApplicationEnvironmentContext } from "./ApplicationEnvironmentContext";

// eslint-disable-next-line max-len
import { jsx as _jsx } from "react/jsx-runtime";
export const ApplicationEnvironmentContextProvider = props => {
  const {
    children
  } = props;
  const {
    Provider
  } = ApplicationEnvironmentContext;
  const [mode, setMode] = React.useState(null);
  React.useEffect(() => {
    setMode(getEnv());
  }, []);
  return React.useMemo(() => /*#__PURE__*/_jsx(Provider, {
    value: mode,
    children: children
  }), [children, mode]);
};